/**
 * Una riga promemoria (KB-SCHEMA Reminder). Ricorda, non prescrive: mostra solo cio che
 * e stato registrato, senza suggerire dosi o modifiche (CLAUDE.md, regole sanitarie).
 * Lo stato e sempre scritto in parole: il colore non comunica da solo.
 */
import type { ReminderChannel, ReminderKind, ReminderStatus } from '@mamma/contracts'

const KIND_LABEL: Record<ReminderKind, string> = {
  farmaco: 'Medicina',
  appuntamento: 'Appuntamento',
  routine: 'Abitudine',
  scadenza: 'Scadenza',
}

const STATUS_LABEL: Record<ReminderStatus, string> = {
  programmato: 'In programma',
  inviato: 'Inviato',
  consegnato: 'Arrivato',
  confermato: 'Fatto',
  fallito: 'Non inviato',
}

const CHANNEL_LABEL: Record<ReminderChannel, string> = {
  in_app: 'nell’app',
  whatsapp: 'su WhatsApp',
}

export type ReminderRowProps = {
  /** Ora locale gia formattata, es. "8:30". */
  time: string
  title: string
  kind: ReminderKind
  status: ReminderStatus
  channels: readonly ReminderChannel[]
  onOpen?: () => void
}

export function ReminderRow({ time, title, kind, status, channels, onOpen }: ReminderRowProps) {
  const where = channels.map((c) => CHANNEL_LABEL[c]).join(' e ')
  return (
    <button
      type="button"
      onClick={onOpen}
      className="motion-colors flex min-h-touch w-full flex-col gap-1 rounded-field border-2 border-line bg-surface px-4 py-3 text-left text-ink"
    >
      {/* Ora e stato sopra, testo a tutta larghezza sotto: a ×1.4 nulla si accavalla. */}
      <span className="flex w-full flex-wrap items-center justify-between gap-2">
        <span className="text-band font-bold">{time}</span>
        <span className="rounded-full bg-chip px-3 py-1 text-meta">{STATUS_LABEL[status]}</span>
      </span>
      <span className="block text-body">{title}</span>
      <span className="text-soft block text-meta">
        {KIND_LABEL[kind]} · {where}
      </span>
    </button>
  )
}
